import React from 'react';
import styled, { css } from 'styled-components';

import { Row } from '../../global/grid/grid';
import colors from '../../../vars/colors';
import gutters from '../../../vars/gutters';
import breakpoints from '../../../vars/breakpoints';

export const MoreCitiesWrapper = styled(Row)`
    .moreCitiesItem {
        &:last-child {
            margin-top: 200px;
            padding-bottom: 50px;
            @media (max-width: ${breakpoints['bp-mobile']}) {
                margin-top: 100px;
            }
        }
        .city {
            font-family: 'OneDotExt', sans-serif;
            font-size: 33px;
            font-weight: bold;
            text-transform: uppercase;
            margin-bottom: 5px;
            &.left {
                color: ${colors['lipstick']};
            }
            &.right {
                color: ${colors['peacock-blue']};
            }
        }
        .state {
            font-family: 'OneDot', sans-serif;
            font-size: 25px;
            letter-spacing: 2.9px;
            font-weight: bold;
            text-transform: uppercase;
            margin-bottom: 30px;
        }
        .imageHolder {
            &:hover {
                .colorBlock {
                    .stripes {
                        animation-play-state: paused;
                    }
                }
            }
        }
    }
    .initialsHolder {
        font-family: 'OneDotCd', sans-serif;
        font-weight: bold;
        color: ${colors['white-two']};
        position: absolute;
        right: 10%;
        top: -140px;
        width: 100%;
        font-size: 250px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        letter-spacing: 10px;
        z-index: -1;
        text-transform: uppercase;
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: none;
        }
    }
    .colorBlock {
        position: absolute;
        z-index: -1;
        width: 80%;
        overflow: hidden;
        &.left {
            top: 33%;
            left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
            @media (max-width: ${breakpoints['bp-desktop']}) {
                left: calc(${gutters['container-gutters-desktop']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                left: calc(${gutters['container-gutters-tablet']} * -0.8);
                bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                left: calc(${gutters['container-gutters-mobile']} * -1);
                bottom: calc(${gutters['container-gutters-mobile']} * -1);
            }
            .arrowCtaHolder {
                transform: rotate(180deg);
                transform-origin: center center;
            }
            .stripes {
                background: repeating-linear-gradient(-45deg, ${colors['lipstick']}, ${colors['lipstick']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
            }
        }
        &.right {
            top: 33%;
            right: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
            @media (max-width: ${breakpoints['bp-desktop']}) {
                right: calc(${gutters['container-gutters-desktop']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                right: calc(${gutters['container-gutters-tablet']} * -0.8);
                bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                right: calc(${gutters['container-gutters-mobile']} * -1);
                bottom: calc(${gutters['container-gutters-mobile']} * -1);
            }
            .stripes {
                background: repeating-linear-gradient(-45deg, ${colors['peacock-blue']}, ${colors['peacock-blue']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
            }
        }
        .stripes {
            position: absolute;
            top: -75px;
            left: -75px;
            right: -75px;
            bottom: -75px;
            animation-name: barbersPole;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-duration: 1200ms;
            animation-play-state: running;
            @keyframes barbersPole {
                0% {transform: translate3d(0, 0, 0)}
                100% {transform: translate3d(0, 72px, 0)}
            }
        }
    }
    .arrowCtaHolder {
        position: absolute;
        top: calc(33% - 43px);
        width: 130px;
        z-index: 3;
        svg {
            width: 100%;
        }
        &.left {
            left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            svg {
                transform-origin: center center;
                transform: rotate(180deg);
            }
            .ctaCopy {
                right: 20%;
                left: 0;
            }
            @media (max-width: ${breakpoints['bp-desktop']}) {
                left: calc(${gutters['container-gutters-desktop']} * -0.8);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                left: calc(${gutters['container-gutters-tablet']} * -0.8);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                left: calc(${gutters['container-gutters-mobile']} * -1);
            }
        }
        &.right {
            transform-origin: center center;
            right: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            .ctaCopy {
                left: 20%;
                right: 0;
            }
            @media (max-width: ${breakpoints['bp-desktop']}) {
                right: calc(${gutters['container-gutters-desktop']} * -0.8);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                right: calc(${gutters['container-gutters-tablet']} * -0.8);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                right: calc(${gutters['container-gutters-mobile']} * -1);
            }
        }
        .ctaCopy {
            position: absolute;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-family: 'OneDotCd', sans-serif;
            font-size: 18px;
            font-weight: bold;
            font-style: italic;
            text-transform: uppercase;
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            position: absolute;
            &.left {
                left: 25px;
                background: ${colors['lipstick']};
            }
            &.right {
                right: 25px;
                background: ${colors['peacock-blue']};
            }
            z-index: 4;
            bottom: 60px;
            display: inline-block;
            height: 50px;
            width: 100px;
            border-radius: 3px;
            &.left,
            &.right {
                top: auto;
                bottom: 20px;
                .ctaCopy {
                    left: 0;
                    top: 0;
                    width: 100%;
                }
            }
            svg {
                display: none;
            }
        }
    }
`;

export const Title = styled.div`
    display: inline-block;
    font-family: 'OneDot';
    font-size: 25px;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: ${colors['peacock-blue']};
    border-bottom: solid 15px ${colors['white-two']};
    margin-bottom: 100px;
    .carrot {
        margin-left: 5px;
        display: inline-block;
        height: 15px;
        width: 15px;
        box-sizing: border-box;
        transform-origin: center center;
        border-bottom: 5px solid ${colors['peacock-blue']};
        border-left: 5px solid ${colors['peacock-blue']};
        border-radius: 2px;
        transform: translate(0, -5px) rotate(-45deg);
    }
`;


// WEBPACK FOOTER //
// ./src/components/modules/MoreCities/styled-components.js